import { isGameUpsellContext, premiumPageContext, type PremiumClickContext } from './premiumAnalytics';
import type { premiumOffer } from '../pages/PremiumPage/offer';

/** Accounts and the Premium landing page are included in first-party analytics. */
export function isDatabaseUpsellContext(path: string, context?: string): boolean {
  return isGameUpsellContext(path, context) || /^\/account(?:\/|$)/.test(path) || /^\/premium\/?$/.test(path);
}

export function recordUpsellImpression(path: string, details: PremiumClickContext, offer?: ReturnType<typeof premiumOffer>): void {
  if (!isDatabaseUpsellContext(path, details.context)) return;
  try {
    void fetch('/api/analytics/events', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName: 'premium_offer_upsell_viewed_v2',
        context: {
          page: premiumPageContext(path), feature: details.feature ?? 'all',
          placement: details.placement, context: details.context, theme: details.theme,
          target_tier: details.targetTier,
          visible_ms: 1000, visible_percent: 100,
          ...(offer?.ready ? {
            variant: offer.variant, experiment: offer.experiment, offer_code: offer.offerCode,
            amount_minor: offer.checkoutAmountMinor ?? offer.amountMinor,
            displayed_amount_minor: offer.amountMinor, currency: offer.currency,
          } : {}),
        },
      }),
    }).catch(() => { /* Best effort; retrying could duplicate a recorded impression. */ });
  } catch { /* Analytics must not interrupt the UI. */ }
}
